//  ----------      START   IMPORT  BLOCK       ----------
//  Services
import APIService from '../Core/APIService';
//  Config
import API_ROUTES from '../../ConfigFiles/Routes/api_routes';
//  ----------      END   IMPORT  BLOCK       ----------


export default class UserPrescriptionService extends APIService {

  async updatePrescription(dataToSend) {
    try {
        return this.put(API_ROUTES.update_user_prescriptions, dataToSend);
    } catch (error) {
        console.error("Error updating allergies:", error);
      throw error;
    }
  }
}